export function isVerificationRequired(response) {
  if (!response) return false;
  if (response.body?.needsVerification || response.needsVerification) return true;
  let message = (response.body?.notification?.text || response.notification?.text || '').toLowerCase();
  return message.includes('confirmation code')
    || message.includes('unverified')
    || message.includes('check your email')
    || message.includes('finish signing in');
}

export function redirectToEmailVerification({ email, password, message }) {
  localStorage.removeItem('access_token');
  localStorage.setItem('REGISTER_PARAMS_EMAIL', email || '');
  if (password) {
    sessionStorage.setItem('PENDING_LOGIN_PASSWORD', password);
  }
  if (message) {
    sessionStorage.setItem('PENDING_VERIFICATION_MESSAGE', message);
  }
  window.location.assign('/auth/register/confirm');
}

export function getVerificationRedirectPayload(response, credentials) {
  return {
    email: response.body?.email || response.email || credentials.email,
    password: credentials.password,
    message: response.body?.notification?.text || response.notification?.text,
  };
}
